
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edfis",
      function () {
        return require("private-next-pages/edfis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/edfis"])
      });
    }
  